import apiFetch from '../apiFetch'

export default function (token, suppliedId) {
  return apiFetch({ endPoint: `SuppliedType/${suppliedId}/Recover`, method: 'PUT', suppliedTypeId: null, token: token })
}
